import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  LEADERBOARD_CONFIGURATIONS_PATH,
  LEADERBOARD_CONFIGURATIONS_ADD_PATH,
  LEADERBOARD_CONFIGURATIONS_UPDATE_PATH,
  LEADERBOARDS_LIST_PATH,
  LEADERBOARDS_PATH,
  LEADERBOARD_WINNERS_LIST_PATH,
  LEADERBOARD_WINNERS_PATH,
  LEADERBOARD_MEMBERS_LIST_PATH,
  LEADERBOARD_MEMBERS_PATH,
} from "utils/constants/paths";

const LeaderboardConfigurations = Loadable(React.lazy(() => import("./View")));
const LeaderboardConfigurationsAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);
const Leaderboards = Loadable(React.lazy(() => import("./View/Leaderboards")));
const Winners = Loadable(React.lazy(() => import("./View/Winners")));
const Members = Loadable(React.lazy(() => import("./View/Members")));

export const LeaderboardRoute: IRouteItem = {
  path: LEADERBOARD_CONFIGURATIONS_PATH,
  iconName: "Rank",
  element: React.createElement(LeaderboardConfigurations),
  name: "Leaderboards",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: LEADERBOARD_CONFIGURATIONS_ADD_PATH,
      element: React.createElement(LeaderboardConfigurationsAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: LEADERBOARD_CONFIGURATIONS_UPDATE_PATH,
      element: React.createElement(LeaderboardConfigurationsAddOrUpdate),
      showInDrawer: false,
    },
    {
      name: "List",
      path: LEADERBOARDS_LIST_PATH,
      element: "",
      showInDrawer: false,
    },
    {
      path: LEADERBOARDS_PATH,
      element: React.createElement(Leaderboards),
      showInDrawer: false,
    },
    {
      name: "Winners",
      path: LEADERBOARD_WINNERS_LIST_PATH,
      element: "",
      showInDrawer: false,
    },
    {
      path: LEADERBOARD_WINNERS_PATH,
      element: React.createElement(Winners),
      showInDrawer: false,
    },
    {
      name: "Members",
      path: LEADERBOARD_MEMBERS_LIST_PATH,
      element: "",
      showInDrawer: false,
    },
    {
      name: "Members",
      path: LEADERBOARD_MEMBERS_PATH,
      element: React.createElement(Members),
      showInDrawer: false,
    },
  ],
};
